import { lazy } from 'react'
export const RootApp = lazy(() => /^\/(?:f|fb|booking)\//.test(window.location.pathname) ? import('./PublicFormsApp') : import('./ManagedApp'))
